<script setup>
const props = defineProps({
  title: {
    type: String,
  },
  items: {
    type: Array,
    default: () => [],
  },
})
</script>

<template>
  <div class="row">
    <div class="col-12">
      <Subcategory
        :title="props.title"
        :items="props.items"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
